<template>
  <div class="slideshow">
    <div class="slideshow__title">
      <slot name="title"></slot>
    </div>
    <div class="slideshow__body">
      <div class="slideshow__control">
        <a @click="$emit('previous')">
          <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.25 37.5L18.75 25l12.5-12.5" stroke-width="3"
             stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
      <div class="slideshow__slot">
        <slot></slot>
      </div>
      <div class="slideshow__control">
        <a @click="$emit('next')">
          <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.75 37.5L31.25 25l-12.5-12.5" stroke-width="3"
             stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slideshow',
  created() {
    window.addEventListener('keyup', this.keyListener);
  },
  destroyed() {
    window.removeEventListener('keyup', this.keyListener);
  },
  methods: {
    keyListener(event) {
      const arrows = { left: 37, right: 39 };
      if (event.srcElement !== document.body) return;
      if (event.which === arrows.left) {
        this.$emit('previous');
      } else if (event.which === arrows.right) {
        this.$emit('next');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.slideshow {
  margin: 0 auto 30px;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 300px);
  &__title {
    text-align: center;
    font-weight: 500;
    margin: 20px auto 40px;
    small {
      display: block;
      font-weight: normal;
      color: var(--color-link-inactive);
      margin-top: 5px;
    }
    .disabled {
      color: var(--color-link-inactive);
    }
  }
  &__body {
    width: 100%;
    display: flex;
    flex: 1;
    padding: 30px 0;
  }
  &__control {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    a {
      svg > path {
        stroke: var(--color-dark);
      }
      &:hover {
        svg > path {
          stroke: var(--color-link);
        }
      }
    }
    &:last-child {
      justify-content: flex-end;
    }
  }
  &__slot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 700px;
    max-width: 100%;
  }
}
</style>
